class contact_form {
  constructor() {
    this.ContactForm = document.getElementById('ContactForm');

    this.init();
  }
  init() {
    // Handle form submissions
    this.ContactForm.querySelector('.contact__button button').addEventListener('click', (event) =>
      this.handleFormSubmit(event, 'contactform')
    );
  }

  async handleFormSubmit(event, formType) {
    event.preventDefault();
    const form = this.ContactForm;

    // Validate form before submission
    if (!this.validateForm(form)) {
      return;
    } else {
      // If validation passes, submit the form
      form.submit();
    }
  }

  validateForm(form) {
    let valid = true;
    // const inputs = form.querySelectorAll('input.input-container__input');
    const inputs = form.querySelectorAll('.input-container input, .input-container textarea');

    inputs.forEach((input) => {
      const errorMessage = input.nextElementSibling;
      if (input.value.trim() === '') {
        this.showError(input, `${input.dataset.name} is required.`);
        valid = false;
      } else if (input.type === 'email' && !this.isValidEmail(input.value)) {
        this.showError(input, window.accesspopup.emailError);
        valid = false;
      } else {
        this.clearError(input);
      }
    });

    return valid;
  }
  isValidEmail(email) {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailPattern.test(email);
  }
  showError(input, message) {
    const inputContainer = input.closest('.input-container');

    if (!inputContainer) {
      console.error('Input field must be wrapped in a div with class "input-container".');
      return;
    }
    // Remove existing successIcon icon
    const successIcon = inputContainer.querySelector('.success-icon');
    if (successIcon) {
      successIcon.remove();
    }
    // Check if error icon already exists
    let errorIcon = inputContainer.querySelector('.error-icon');
    inputContainer.classList.add('show-error');
    inputContainer.classList.remove('show-success');
    if (errorIcon == null) {
      errorIcon = document.createElement('span');
      errorIcon.classList.add('error-icon');
      errorIcon.innerHTML = `
           <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15.9133 14.7516L8.3754 0.734036C8.29762 0.589308 8.15376 0.5 7.99786 0.5C7.84197 0.5 7.6981 0.589308 7.62033 0.734036L0.0583302 14.7979C-0.0194434 14.9426 -0.0194434 15.1212 0.0583302 15.266C0.136104 15.4107 0.279968 15.5 0.435863 15.5H15.5606C15.562 15.5 15.5634 15.5 15.564 15.5C15.8049 15.5 16 15.2905 16 15.0319C16 14.9267 15.9677 14.8297 15.9133 14.7516ZM1.19093 14.5639L7.99786 1.9044L14.8055 14.5639H1.19093ZM7.99786 11.8226C7.75705 11.8226 7.56191 12.0322 7.56191 12.2907V12.384C7.56191 12.6425 7.75705 12.852 7.99786 12.852C8.23868 12.852 8.43382 12.6425 8.43382 12.384V12.2907C8.43382 12.0322 8.23868 11.8226 7.99786 11.8226ZM7.56191 6.04196V10.3825C7.56191 10.641 7.75705 10.8506 7.99786 10.8506C8.23868 10.8506 8.43382 10.641 8.43382 10.3825V6.04196C8.43382 5.7834 8.23868 5.57389 7.99786 5.57389C7.75705 5.57389 7.56191 5.7834 7.56191 6.04196Z" fill="#C01616"/>
          </svg>`;
      inputContainer.appendChild(errorIcon);
    }

    // Check if error message already exists
    let errorMessage = inputContainer.querySelector('.error-message');
    if (errorMessage == null) {
      errorMessage = document.createElement('p');
      errorMessage.style.display = 'block';
      errorMessage.classList.add('error-message');
      inputContainer.appendChild(errorMessage);

      // Update error message text
      errorMessage.textContent = message;
      // Add error styling to input
      input.classList.add('input-error');
    }
  }

  clearError(input) {
    const inputContainer = input.closest('.input-container');
    if (!inputContainer) {
      console.error('Input field must be wrapped in a div with class "input-container".');
      return;
    }

    inputContainer.classList.remove('show-error');
    inputContainer.classList.add('show-success');
    // Remove existing error icon
    const errorIcon = inputContainer.querySelector('.error-icon');
    if (errorIcon) {
      errorIcon.remove();
    }

    // Remove error message
    const errorMessage = inputContainer.querySelector('.error-message');
    if (errorMessage) {
      errorMessage.remove();
    }

    // Remove error styling
    input.classList.remove('input-error');

    // Check if success icon already exists
    let successIcon = inputContainer.querySelector('.success-icon');
    if (!successIcon) {
      // Create a success icon
      successIcon = document.createElement('span');
      successIcon.classList.add('success-icon');
      successIcon.innerHTML = `
           <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8 0C3.58178 0 0 3.58178 0 8C0 12.4182 3.58178 16 8 16C12.4182 16 16 12.4182 16 8C16 3.58178 12.4182 0 8 0ZM8 14.4C4.47096 14.4 1.6 11.5289 1.6 8C1.6 4.47096 4.47096 1.6 8 1.6C11.529 1.6 14.4 4.47096 14.4 8C14.4 11.5289 11.529 14.4 8 14.4Z" fill="#0B853E"/>
<path d="M6.96562 9.0343L4.79984 6.86852L3.66876 7.99994L6.9658 11.297L12.3314 5.93135L11.2 4.79993L6.96562 9.0343Z" fill="#0B853E"/>
</svg>

        `;

      // Append success icon to input container
      inputContainer.appendChild(successIcon);
    }
  }
}

// Initialize the modal functionality when the DOM is ready
document.addEventListener('DOMContentLoaded', () => new contact_form());
